import React from "react";
import { Icon } from "./Icon";

const tones = {
  neutral: { background: "var(--surface-muted)", color: "var(--text-body)" },
  gold: { background: "var(--hive)", color: "var(--text-on-primary)" },
  master: { background: "var(--surface-master)", color: "var(--text-on-master)" },
  trust: { background: "var(--surface-trust)", color: "var(--text-trust)" },
  success: { background: "var(--success-tint)", color: "var(--success)" },
  warning: { background: "var(--warning-tint)", color: "var(--warning)" },
  danger: { background: "var(--danger-tint)", color: "var(--danger)" },
  inverse: { background: "var(--surface-inverse)", color: "var(--hive)" },
};

export function Badge({ tone = "neutral", icon, children, style = {}, ...rest }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "var(--space-1)",
      borderRadius: "var(--radius-sm)", padding: "4px 10px",
      fontFamily: "var(--font-display)", fontSize: "var(--text-2xs)",
      fontWeight: "var(--weight-semibold)", textTransform: "uppercase",
      letterSpacing: "var(--tracking-wider)", lineHeight: 1.4,
      ...tones[tone], ...style,
    }} {...rest}>
      {icon && <Icon name={icon} size={11} />}
      {children}
    </span>
  );
}
